import React, { ReactNode, useEffect, useRef, useState } from "react";
import { useViewer } from "../../../app/hooks/hooks";
import classes from "./ViewerContextMenu.module.css";
import ContextMenu from "../../ContextMenu/ContextMenu";
import { visibilityTrigger } from "../ViewerKeyBoardEvents/ViewerKeyBoardEvents";
interface ViewerContextMenuProps {
    children: ReactNode;
    enable: boolean;
}
function ViewerContextMenu({ children, enable }: ViewerContextMenuProps) {
    const viewer = useViewer();
    const [show, setShow] = useState<{ x: number; y: number } | null>(null);
    const [touchStart, setTouchStart] = useState(0);
    const ref = useRef();

    const hideHandle = () => {
        if (!viewer) return;
        viewer.utils.geometryUtils.hideSelectedElements();
        visibilityTrigger(viewer);
    };
    const isolateHandle = () => {
        if (!viewer) return;
        viewer.utils.geometryUtils.isolateSelectedElements();
        visibilityTrigger(viewer);

        // viewer.context.controls.setOrbitByTarget()
    };
    const showAllHandle = () => {
        if (!viewer) return;
        viewer.utils.geometryUtils.showAll();
        visibilityTrigger(viewer);
    };

    const onContextMenuHandle = (e: any) => {
        if (
            viewer?.utils?.osUtils.OS === "Android" ||
            viewer?.utils?.osUtils.OS === "IOS"
        ) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (!enable) return;
        setTimeout(() => {
            if (!viewer?.context.controls.moving) {
                setShow({ x: e.clientX, y: e.clientY });
            }
        }, 300);
    };

    const data = [
        { content: "Hide selected", handle: hideHandle },
        { content: "Isolate selected", handle: isolateHandle },
        { content: "Show all", handle: showAllHandle },
    ];
    return (
        <div
            className={classes.viewerContextMenuWrap}
            onContextMenu={onContextMenuHandle}
            onTouchStart={() => {
                if (
                    viewer?.utils?.osUtils.OS === "Android" ||
                    viewer?.utils?.osUtils.OS === "IOS"
                ) {
                    setTimeout(() => {
                        if (show) {
                            setShow(null);
                        }
                    }, 200);
                    setTouchStart(Date.now());
                }
            }}
            onMouseMove={(e) => {
                if (
                    !ref.current ||
                    viewer?.utils?.osUtils.OS === "Android" ||
                    viewer?.utils?.osUtils.OS === "IOS"
                )
                    return;
                if (!show) return;
                const contextMenuRect = (
                    ref.current! as any
                ).getBoundingClientRect();
                if (
                    contextMenuRect.top <= e.clientY + 2 &&
                    contextMenuRect.bottom >= e.clientY - 2 &&
                    contextMenuRect.left <= e.clientX + 2 &&
                    contextMenuRect.right >= e.clientX - 2
                ) {
                } else {
                    setShow(null);
                }
            }}
            onMouseUp={() => {}}
            onTouchEnd={(e) => {
                if (
                    Date.now() - touchStart > 400 &&
                    !viewer?.context.controls.moving &&
                    (viewer?.utils?.osUtils.OS === "Android" ||
                        viewer?.utils?.osUtils.OS === "IOS")
                ) {
                    setShow({
                        x: e.changedTouches[0].clientX,
                        y: e.changedTouches[0].clientY,
                    });
                }
            }}
        >
            {show ? (
                <ContextMenu
                    data={data}
                    position={show}
                    close={setShow}
                    //@ts-ignore
                    contextRef={ref}
                ></ContextMenu>
            ) : (
                <></>
            )}
            {children}
        </div>
    );
}

export default ViewerContextMenu;
